import * as Types from '../constants/ActionTypes';
import IReducerAction from '../interfaces/ReducerAction';

const initialState = {
  where: null,
  whoOpened: null,
  year: null
};

const navbar = (_state = initialState, action: IReducerAction) => {
  switch(action.type) {
    case Types.LEARNMORE:
      return { whoOpened: "LEARNMORE", where: action.payload };
    case Types.COUNCILSAYS:
      return { whoOpened: "COUNCILSAYS", where: action.payload.section, year: action.payload.year };
    case Types.JUMPTO:
      return { whoOpened: "JUMPTO", where: action.payload };
    case Types.NONE:
      return initialState;
    default:
      return initialState;
  }
};

export default navbar;



// WEBPACK FOOTER //
// ./src/reducers/navbar.ts